"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  getCreateGiftState: true,
  getRecipient: true,
  getRecipientIsLoading: true,
  getRecipientIsTryLoading: true
};
exports.getRecipientIsTryLoading = exports.getRecipientIsLoading = exports.getRecipient = exports.getCreateGiftState = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _gift = require("./gift/gift.selector");

Object.keys(_gift).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _gift[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _gift[key];
    }
  });
});

var _campaigns = require("./campaigns/campaigns.selector");

Object.keys(_campaigns).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _campaigns[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _campaigns[key];
    }
  });
});

var _message = require("./gift/postcard/message/message.selectors");

Object.keys(_message).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _message[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _message[key];
    }
  });
});

var _marketplace = require("./marketplace/marketplace.selector");

Object.keys(_marketplace).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _marketplace[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _marketplace[key];
    }
  });
});

var _address = require("./address/address.selectors");

Object.keys(_address).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _address[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _address[key];
    }
  });
});

var _shipping = require("./shipping/shipping.selectors");

Object.keys(_shipping).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _shipping[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _shipping[key];
    }
  });
});

var _product = require("./product/product.selectors");

Object.keys(_product).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _product[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _product[key];
    }
  });
});
var getCreateGiftState = R.prop('createGift');
exports.getCreateGiftState = getCreateGiftState;
var getRecipient = R.path(['createGift', 'recipient']);
exports.getRecipient = getRecipient;
var getRecipientIsLoading = R.path(['createGift', 'recipient', 'isLoading']);
exports.getRecipientIsLoading = getRecipientIsLoading;
var getRecipientIsTryLoading = R.path(['createGift', 'recipient', 'isTryLoading']);
exports.getRecipientIsTryLoading = getRecipientIsTryLoading;